module.exports = __webpack_public_path__ + "img/2.a9174bf5.png";